import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

export interface SectionCardProps {
  title?: ReactNode
  icon?: ReactNode
  description?: ReactNode
  action?: ReactNode
  flush?: boolean
  className?: string
  bodyClassName?: string
  children: ReactNode
}

export function SectionCard({ title, icon, description, action, flush, className, bodyClassName, children }: SectionCardProps) {
  const hasHeader = Boolean(title || description || action)
  return (
    <section className={cn('rounded-2xl border border-border bg-card text-card-foreground shadow-xs', flush && 'overflow-hidden', className)}>
      {hasHeader && (
        <header className="flex flex-wrap items-start justify-between gap-x-4 gap-y-3 border-b border-border px-4 py-3.5 sm:flex-nowrap sm:px-5">
          <div className="min-w-0 space-y-0.5">
            {title && (
              <h2 className="flex items-center gap-2 text-sm font-semibold leading-6 [&_svg]:h-4 [&_svg]:w-4 [&_svg]:shrink-0 [&_svg]:text-muted-foreground">
                {icon}
                {title}
              </h2>
            )}
            {description && <p className="text-[13px] leading-snug text-muted-foreground">{description}</p>}
          </div>
          {action && <div className="flex max-w-full shrink-0 items-center gap-2">{action}</div>}
        </header>
      )}
      <div className={cn(!flush && 'p-4 sm:p-5', bodyClassName)}>{children}</div>
    </section>
  )
}
